import { useAppTheme } from "@hooks/useAppTheme";
import { useDevice } from "@hooks/useDevice";
/* -----------------UI--------------- */
import Box from "@memorang/ui/components/Box";
import { TextSkeleton } from "@memorang/ui/components/ChatUI/TextSkeleton";
import { StatsSkeleton } from "@memorang/ui/components/Skeletons/StatsSkeleton";
import { Card, Divider } from "react-native-paper";

export const SummaryCardSkeleton = () => {
	const theme = useAppTheme();
	const { isMobile } = useDevice();

	return (
		<Card
			style={{
				width: "100%",
			}}
		>
			<Box gap={16}>
				{/* Card Header with Donut Score overlapping top edge */}
				<Box
					gap={16}
					flexDirection="column"
					alignItems="center"
					position="relative"
				>
					{/* Donut Score Skeleton - Positioned absolutely to overlap card edge */}
					<Box
						top={-54}
						backgroundColor={theme.colors.elevation.level1}
						position="absolute"
						alignSelf="center"
						width={100}
						height={100}
						borderRadius={50}
						zIndex={1}
						padding={8}
						alignItems="center"
						justifyContent="center"
					/>

					{/* Score Range Skeleton */}
					<Box width={200} marginTop={58}>
						<TextSkeleton numLines={1} height={16} />
					</Box>

					{/* Title and Feedback Skeleton */}
					<Box alignItems="center" width="40%">
						<TextSkeleton numLines={1} height={14} />
						<TextSkeleton numLines={1} height={14} />
					</Box>

					{/* Continue Button (desktop only) */}
					{!isMobile && (
						<Box width={120}>
							<TextSkeleton numLines={1} height={40} />
						</Box>
					)}
					{isMobile && <Box height={16} />}
				</Box>

				<Divider
					style={{
						backgroundColor: theme.colors.surfaceVariant,
					}}
				/>
			</Box>

			{/* Stats Section */}
			<Box paddingVertical={2} paddingHorizontal={16} alignItems="center">
				<StatsSkeleton numRows={3} />
			</Box>
		</Card>
	);
};
